var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-card"},[_c('module-title',{attrs:{"module-title":_vm.moduleTitle}}),_vm._v(" "),_c('img',{staticClass:"imgs",attrs:{"src":_vm.item.img},on:{"click":function($event){return _vm.goInfo(_vm.item)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2a0845a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TimeCard.vue
// module id = null
// module chunks = 